import { jsx as _jsx } from "react/jsx-runtime";
import { DisputeFeature } from './typings';
import AllDisputes from './pages/AllDisputes';
import Questionnaire from './pages/Questionnaire';
import TransactionEligible from './pages/TransactionEligible';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { t } from './strings/i18n/i18n';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { getLanguageFromStorage } from 'syf-js-utilities';
import { openModal } from './redux/ui/ui.slice';
import { ModalType } from './redux/ui/typings';
var SyfDisputes = function (_a) {
    var selectedDispute = _a.selectedDispute, feature = _a.feature, navigationHandler = _a.navigationHandler, navigationItems = _a.navigationItems, eligibilityPortalId = _a.eligibilityPortalId;
    var dispatch = useDispatch();
    var language = getLanguageFromStorage();
    var isMobile = useWindowSize().isLessThanTablet;
    /**
     * We need to explicitly set the selected language on these translations due to a sync issue when toggling the language on Vista.
     * The root cause isn't clear, but it likely has to do with the component not refreshing with the rest of the app on language toggle.
     */
    var navItems = navigationItems !== null && navigationItems !== void 0 ? navigationItems : [
        {
            label: t('allDisputes.backToActivity', { lng: language }),
            navigationKey: 'activity'
        },
        {
            label: t('allDisputes.manageDisputes', { lng: language }),
            navigationKey: 'disputes',
            active: true
        }
    ];
    // On mobile, we only want to display non-active items to reduce UI footprint
    var passedItems = isMobile
        ? navItems.filter(function (item) { return item.active !== true; })
        : navItems;
    var navigation = { navigationHandler: navigationHandler, navigationItems: passedItems };
    useEffect(function () {
        if (selectedDispute) {
            dispatch(openModal(ModalType.DisputeDetail));
        }
    }, [dispatch, selectedDispute]);
    switch (feature) {
        case DisputeFeature.Questionnaire:
            return _jsx(Questionnaire, {});
        case DisputeFeature.DisputeCenter:
            return _jsx(AllDisputes, { navigation: navigation });
        case DisputeFeature.Eligibility:
            return _jsx(TransactionEligible, { portalId: eligibilityPortalId });
        default:
            return null;
    }
};
export default SyfDisputes;
//# sourceMappingURL=SyfDisputes.js.map